export default {
  local: 'http://127.0.0.1:5000',
  staging: 'https://localhost:5000',
  production: 'https://sulamericabackoffice.apps.cli.inova1.space',
}
